import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import {BrowserRouter} from 'react-router-dom';
import {Provider} from 'react-redux';

//import App from  './components/App';
import AppContainer from './containers/AppContainer';
import store from './redux/store';

ReactDOM.render((
    <BrowserRouter>
        <Provider store={store}>
            <AppContainer></AppContainer>
        </Provider>
    </BrowserRouter>
), document.getElementById("root"));